export const ComplaintTypeEnum = Object.freeze({
  Harassment: 0, // General harassment
  SexualHarassment: 1, // Sexual harassment
  Discrimination: 2, // Discrimination (age, gender, race, etc.)
  Bullying: 3, // Bullying or intimidation
  UnprofessionalBehavior: 4, // Unprofessional conduct
  PolicyViolation: 5, // Violation of company policies
  WorkplaceSafetyConcern: 6, // Safety hazard or unsafe practices
  AttendanceIssue: 7, // Attendance or punctuality issues
  Misconduct: 8, // Misconduct or insubordination
  ConflictOfInterest: 9, // Conflict of interest
  TheftOrFraud: 10, // Theft, fraud, or dishonesty
  Other: 11, // Other (custom input required)
});

export const ComplaintTypeLabel = Object.freeze({
  [ComplaintTypeEnum.Harassment]: "Harassment",
  [ComplaintTypeEnum.SexualHarassment]: "Sexual Harassment",
  [ComplaintTypeEnum.Discrimination]: "Discrimination",
  [ComplaintTypeEnum.Bullying]: "Bullying / Intimidation",
  [ComplaintTypeEnum.UnprofessionalBehavior]: "Unprofessional Behavior",
  [ComplaintTypeEnum.PolicyViolation]: "Policy Violation",
  [ComplaintTypeEnum.WorkplaceSafetyConcern]: "Workplace Safety Concern",
  [ComplaintTypeEnum.AttendanceIssue]: "Attendance / Punctuality Issue",
  [ComplaintTypeEnum.Misconduct]: "Misconduct / Insubordination",
  [ComplaintTypeEnum.ConflictOfInterest]: "Conflict of Interest",
  [ComplaintTypeEnum.TheftOrFraud]: "Theft / Fraud",
  [ComplaintTypeEnum.Other]: "Other",
});
